export class TemplateConfig {
  constructor(component) {
    this._component = component;
    this._hideNavigation = false;
    this._controlsLayoutContext = false;
    this._hideMobileNavigation = false;
    this._deprecatedDebouncePageLoads = false;
  }

  static build(component) {
    return new TemplateConfig(component);
  }

  hideNavigation() {
    this._hideNavigation = true;

    return this;
  }

  hideMobileNavigation() {
    this._hideMobileNavigation = true;

    return this;
  }

  controlsLayoutContext() {
    this._controlsLayoutContext = true;

    return this;
  }

  isNavigationHidden() {
    return this._hideNavigation;
  }

  isMobileNavigationHidden() {
    return this._hideMobileNavigation;
  }

  checkIfControlsLayoutContext() {
    return this._controlsLayoutContext;
  }

  /**
   * @deprecated
   *
   * @summary Avoid this like the plague. If you're copy-pasting, please remove this.
   *
   * @description In the past, we had a confusing behavior.
   * If you asked page context to refresh twice, or load pages twice, it would silently ignore your second request if the first one hadn't finished.
   *
   * For example, in whatif you could edit an expense, hit save, and a refresh would begin.
   * Then you could edit an income, hit save, and that would tell page context to refresh again.
   * But if page context was still waiting on the response for the first request, that second refresh would never happen!
   * This would be very confusing for planners as they saw outdated info.
   *
   * We wanted to change the default going forward, but maintain the old functionality for old pages to avoid breaking them.
   * Going forward, you should never add this again to a new page.
   * If you actually want the behavior of "ignore any refresh/load calls while refresh/load is in progress", you can achieve that explicitly.
   * Just write a hook for that, and let people opt-into it whenever needed (very rarely, if ever)
   */
  deprecatedDebouncePageLoads() {
    this._deprecatedDebouncePageLoads = true;

    return this;
  }

  isUsingDeprecatedDebouncePageLoads() {
    return this._deprecatedDebouncePageLoads;
  }

  component() {
    return this._component;
  }
}
